<template>
  <div>
    <b-row class="d-flex align-items-center">
      <b-col cols="8">
        <h1 class="font-weight-bolder mb-0">
          Create Push Notification Campaign
        </h1>
      </b-col>
      <b-col cols="4" class="text-right">
        <b-button size="md" variant="outline-secondary" class="mr-1">
          <span class="text-lg text-nowrap" style="margin-left: 4px"
            >Cancel</span
          >
        </b-button>
        <b-button size="md" variant="primary">
          <span class="text-lg text-nowrap" style="margin-left: 4px"
            >Save & Draft</span
          >
        </b-button>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col cols="6">
              <p class="font-weight-bold mb-0">Campaign Name*</p>
              <b-form-input
                placeholder="e.g. Weekend Sports Alert"
                v-model="campaignName"
                type="text"
              />
            </b-col>
            <b-col cols="6">
              <p class="font-weight-bold mb-0">Internal Description</p>
              <b-form-input
                placeholder="For internal use only"
                v-model="referenceCode"
                type="text"
              />
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Status</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Target Audience</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Customer Segments</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
          </b-row>

          <b-row class="mt-1 d-flex align-items-end">
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Notification Title*</p>
              <b-form-input
                placeholder="e.g. Weekend Sports Alert"
                v-model="campaignName"
                type="text"
              />
            </b-col>
            <b-col cols="12" md="8">
              <b-row>
                <b-col md="10">
                  <p class="font-weight-bold mb-0">Notification Message*</p>
                  <b-form-textarea
                    placeholder="Enter the notification message..."
                    rows="2"
                  ></b-form-textarea>
                </b-col>
                <b-col md="2">
                  <p class="font-weight-bold mb-0">Emoji/Icon</p>
                  <b-form-input
                    placeholder="e.g. 🎉"
                    v-model="campaignName"
                    type="text"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Action Button Text</p>
              <b-form-input
                placeholder="e.g. Claim Now"
                v-model="campaignName"
                type="text"
              />
            </b-col>
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Deep Link / URL</p>
              <b-form-input
                placeholder="e.g. /promotions/free-bet-offers"
                v-model="campaignName"
                type="text"
              />
            </b-col>
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Image (optional)</p>
              <b-form-file placeholder="" />
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Schedule Date</p>
              <flat-pickr
                id="startDate"
                v-model="startDate"
                class="form-control"
                :config="configDate"
                placeholder="mm/dd/yyyy"
              />
            </b-col>
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Schedule Time</p>
              <flat-pickr
                id="startDate"
                v-model="startDate"
                class="form-control"
                :config="configTime"
                placeholder="mm/dd/yyyy"
              />
            </b-col>
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Time Zone</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">Frequency</p>
              <v-select
                :value="option"
                :options="options"
                :reduce="(val) => val.value"
                :clearable="false"
                @input="(val) => (option = val.value)"
                class="w-100"
              />
            </b-col>
            <b-col cols="12" md="4">
              <p class="font-weight-bold mb-0">End Date</p>
              <flat-pickr
                id="startDate"
                v-model="startDate"
                class="form-control"
                :config="configDate"
                placeholder="mm/dd/yyyy"
              />
            </b-col>
            <b-col cols="12" md="4"> </b-col>
          </b-row>

          <b-row class="mt-1">
            <b-col cols="12" md="6">
              <h4 class="font-weight-bolder text-body mb-0 text-nowrap">
                Targeting Preview
              </h4>
              <b-card border-variant="secondary" class="mt-1">
                <p><strong>Audience: </strong> All App Users</p>
                <p><strong>Segments:</strong> All Segments</p>
                <p>
                  <strong>Scheduled:</strong>
                  2025-06-21 10:00 AM
                </p>
                <p><strong>Message:</strong> Australia/Sydney</p>
              </b-card>
            </b-col>

            <b-col cols="12" md="6">
              <h4 class="font-weight-bolder text-body mb-0 text-nowrap">
                Notification Simulator
              </h4>
              <b-card border-variant="secondary" class="mt-1">
                <div style="width: 220px" class="mx-auto">
                  <div class="rounded bg-black p-1">
                    <div class="d-flex align-items-center">
                      <p class="text-white mb-0" style="font-weight: 20px">
                        🎉
                      </p>
                      <p
                        class="text-white font font-weight-bolder mb-0"
                        style="font-weight: 20px"
                      >
                        Your Weekend Free Bet Awaits!
                      </p>
                    </div>
                    <span class="text-white"
                      >Enter the notification message...</span
                    >
                  </div>
                  <b-button variant="primary" size="sm" class="mt-1 w-100"
                    >Claim now</b-button
                  >
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="text-right">
              <b-button size="md" variant="outline-secondary" class="mr-1">
                <span class="text-lg text-nowrap" style="margin-left: 4px"
                  >Cancel</span
                >
              </b-button>
              <b-button size="md" variant="primary">
                <span class="text-lg text-nowrap" style="margin-left: 4px"
                  >Create Campaign</span
                >
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Spinner from "@core/components/Spinner";
import {
  BButton,
  BCard,
  BCol,
  BPagination,
  BRow,
  BButtonGroup,
  BTable,
  BCardBody,
  BFormInput,
  BMedia,
  BAvatar,
  BProgress,
  BProgressBar,
  BFormTextarea,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormGroup,
  BImg,
  BFormCheckboxGroup,
  BFormSelect,
  BFormFile,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";

export default {
  components: {
    BButton,
    BCard,
    BRow,
    BCol,
    BTable,
    BMedia,
    BPagination,
    vSelect,
    Spinner,
    BButtonGroup,
    BTable,
    BCardBody,
    BFormInput,
    BAvatar,
    flatPickr,
    BProgress,
    BProgressBar,
    ValidationProvider,
    ValidationObserver,
    BFormTextarea,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormGroup,
    BImg,
    BFormCheckboxGroup,
    BFormSelect,
    FeatherIcon,
    BFormFile,
  },
  data() {
    return {
      max: 4,
      value: 2,
      campaignName: "",
      referenceCode: "",
      startDate: "",
      endDate: "",
      desc: "",
      configDate: {
        // dateFormat: 'd-m-Y',
        altFormat: "d-m-Y",
        altInput: true,
        static: true,
      },
      time: "",
      configTime: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
      },
      selected: "first",
      options: [
        { text: "Automatically include opt-out instructions", value: "first" },
        { text: "Exclude users who have opted out", value: "second" },
        { text: "Respect Do-Not-Disturb hours", value: "third" },
      ],
      mainProps: {
        blank: true,
        blankColor: "#777",
        width: 32,
        height: 32,
      },
      selected: [],
      optionsCheck: [
        { text: "Homepage Hero", value: "1" },
        { text: "Sidebar", value: "2" },
        { text: "In-App Banner", value: "3" },
        { text: "Email Header", value: "4" },
      ],
    };
  },
  computed: {},
  async mounted() {},
  methods: {},
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>
